// Cumulative 2024 Character Advancement thresholds, indexed by character level.
export const XP_THRESHOLDS = Object.freeze([0, 0, 300, 900, 2700, 6500, 14000, 23000, 34000, 48000, 64000, 85000, 100000, 120000, 140000, 165000, 195000, 225000, 265000, 305000, 355000]);
export function experienceProfile(character = {}) {
  const level = Math.max(1, Math.min(20, (character.occupation || []).reduce((sum, entry) => sum + Math.max(0, Number(entry.Level ?? entry.level) || 0), 0)));
  const floor = XP_THRESHOLDS[level];
  const total = Number.isSafeInteger(character.experience?.total) && character.experience.total >= 0 ? character.experience.total : floor;
  const next = level < 20 ? XP_THRESHOLDS[level + 1] : null;
  return { level, total, floor, next, revision: character.experience?.revision || 0, ready: next !== null && total >= next,
    progress: next === null ? 1 : Math.max(0, Math.min(1, (total - floor) / (next - floor))) };
}
export function mergeExperience(character, incoming) {
  if (!incoming || !Number.isSafeInteger(incoming.total) || !Number.isSafeInteger(incoming.revision)) return character;
  return incoming.revision >= (character.experience?.revision || 0) ? { ...character, experience: incoming } : character;
}
